"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChannelCoverUrl = void 0;
function getChannelCoverUrl(channelData) {
    var coverUrl = channelData.coverUrl, customCoverUrl = channelData.customCoverUrl;
    return customCoverUrl || coverUrl;
}
exports.getChannelCoverUrl = getChannelCoverUrl;
//# sourceMappingURL=cover.js.map